// src/sections/dashboard/dashboard-filters-layout.js
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Unstable_Grid2';
import Container from '@mui/material/Container';
import { useSettingsContext } from 'src/components/settings';
import { useGetDevices } from 'src/api/devices';
import AppSelectDevice from 'src/sections/dashboard/app-select-device';
import AppDateTimePickerWidget from 'src/sections/dashboard/app-date-time-picker-widgets';
import AppDateRangePresets from 'src/sections/dashboard/app-date-range-presets';
import AppGlobalFilters from 'src/sections/dashboard/app-global-filters';
import { DashboardFiltersProvider, useDashboardFilters } from './dashboard-filters-context';

function DashboardFiltersBar({ showCancelledFilter = false }) {
  const {
    setSelectedDevices,
    selectedStartTime,
    setSelectedStartTime,
    selectedEndTime,
    setSelectedEndTime,
    realTimeState,
    setRealTimeState,
    filterCancelledShipments,
    setCancelledShipmentState,
    triggerRefresh
  } = useDashboardFilters();

  const { devices, devicesLoading } = useGetDevices();
  const hasRealTimeButton = true;
  const settings = useSettingsContext();

  const handleUpdateShipmentList = useCallback(() => {
  }, []);

  return (
    <Container maxWidth={settings.themeStretch ? false : 'xl'}>
      <Grid container spacing={3} sx={{ mb: 1 }}>
        {devices.length > 1 && (
          <Grid xs={12} md={12}>
            <AppSelectDevice
              devices={devicesLoading ? [] : devices}
              setSelectedDevices={setSelectedDevices}
              updateShipmentList={handleUpdateShipmentList}
              triggerRefresh={triggerRefresh}
            />
          </Grid>
        )}

        <Grid xs={12} md={12}>
          <AppDateRangePresets />
        </Grid>

        <Grid xs={12} md={6} display='flex'>
          <AppDateTimePickerWidget
            label="Início do período"
            initialDateTime={selectedStartTime}
            setDateTime={setSelectedStartTime}
            hasRealTimeButton={!hasRealTimeButton}
            realTimeState={realTimeState}
            setRealTimeState={setRealTimeState}
            triggerRefresh={triggerRefresh}
            updateShipmentList={handleUpdateShipmentList}
          />
        </Grid>

        <Grid xs={12} md={6} display='flex'>
          <AppDateTimePickerWidget
            label="Fim do período"
            initialDateTime={selectedEndTime}
            setDateTime={setSelectedEndTime}
            hasRealTimeButton={hasRealTimeButton}
            realTimeState={realTimeState}
            setRealTimeState={setRealTimeState}
            triggerRefresh={triggerRefresh}
            updateShipmentList={handleUpdateShipmentList}
          />
        </Grid>

        {showCancelledFilter && (
          <Grid xs={12} md={12}>
            <AppGlobalFilters
              filterCancelledShipments={filterCancelledShipments}
              setCancelledShipmentState={setCancelledShipmentState}
            />
          </Grid>
        )}
      </Grid>
    </Container>
  );
}

DashboardFiltersBar.propTypes = {
  showCancelledFilter: PropTypes.bool,
};

function DashboardFiltersLayoutInner({ children, showCancelledFilter, hideFiltersBar }) {
  const { contextKey } = useDashboardFilters();

  return (
    <>
      {!hideFiltersBar && <DashboardFiltersBar showCancelledFilter={showCancelledFilter} />}
      <React.Fragment key={contextKey}>
        {children}
      </React.Fragment>
    </>
  );
}

DashboardFiltersLayoutInner.propTypes = {
  children: PropTypes.node,
  showCancelledFilter: PropTypes.bool,
  hideFiltersBar: PropTypes.bool,
};

export default function DashboardFiltersLayout({
  children,
  showCancelledFilter = false,
  hideFiltersBar = false,
}) {
  return (
    <DashboardFiltersProvider>
      <DashboardFiltersLayoutInner
        showCancelledFilter={showCancelledFilter}
        hideFiltersBar={hideFiltersBar}
      >
        {children}
      </DashboardFiltersLayoutInner>
    </DashboardFiltersProvider>
  );
}

DashboardFiltersLayout.propTypes = {
  children: PropTypes.node,
  showCancelledFilter: PropTypes.bool,
  hideFiltersBar: PropTypes.bool,
};